import { DestroyRef, inject } from "@angular/core";
import { takeWhileAlive } from '@core/frontend-shared/utils';
import { UiButtonComponent } from '@common/ui/frontend-shared/button';
import { BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { BaseFormService, FormState } from '../form-service';
import * as i0 from "@angular/core";
import * as i1 from "@common/ui/frontend-shared/button";
export let FormSubmitButtonDirective = /*#__PURE__*/(() => {
  class FormSubmitButtonDirective {
    set formSubmitButton(arg) {
      if (arg instanceof BaseFormService) {
        this.service = arg;
        arg.state.getState$().pipe(takeWhileAlive(this.destroyRef)).subscribe(state => this.state$.next(state));
      } else if (arg instanceof FormState) {
        arg.getState$().pipe(takeWhileAlive(this.destroyRef)).subscribe(state => this.state$.next(state));
      } else {
        throw new Error('arg passed to formSubmitButton must be a ModelFormService or FormState!');
      }
    }
    set _options(options) {
      this.customLabel = options.label || undefined;
      this.customLabelSent = options.labelSent || undefined;
      this.customIcon = options.icon || undefined;
      this.state$.next(this.state$.value);
    }
    constructor(
    // private el: ElementRef,
    comp) {
      this.comp = comp;
      this.destroyRef = inject(DestroyRef);
      // using a local copy of the original FormState to be able to handle async setup & inputs correctly!
      this.state$ = new BehaviorSubject(null);
      this.e2eStateAttr = "valid";
      this.isSubmitBtn = true;
      // NOTE: don't bind (click) event if you need custom behavior, instead specify [formSubmitHandler].
      this.handler = null;
      this.state$.pipe(filter(state => state !== null)).subscribe(state => {
        // const buttonDisabled = state.hasTriedToSubmitForm && !state.valid
        this.e2eStateAttr = !state.valid && state.hasTriedToSubmitForm ? "invalid" : "valid";
        this.comp.loading = state.busy || state.saveState === 'saving';
        this.comp.label = this.calcButtonLabel(state);
        this.comp.styleClass = this.calcButtonClass(state);
        this.comp.icon = this.calcButtonIcon(state);
        this.comp.cd.detectChanges();
        this.buttonDisabled = undefined;
      });
    }
    calcButtonLabel(state) {
      const {
        busy,
        saveState,
        valid,
        hasTriedToSubmitForm,
        editMode,
        formType,
        changeState
      } = state;
      if (busy || saveState === 'saving') return 'Bitte warten...';
      if (!valid && hasTriedToSubmitForm) return 'Bitte Eingaben prüfen.';
      if (formType === 'editor') {
        if (editMode === 'edit') {
          if (saveState === 'idle' && changeState === 'changed') return this.customLabel || 'Speichern';else return 'Gespeichert';
        } else {
          if (saveState === 'idle') return this.customLabel || 'Erstellen';else return 'Gespeichert';
        }
      } else {
        if (saveState === 'idle') return this.customLabel || 'Senden';
      }
      return this.customLabelSent || 'Erfolgreich gesendet';
    }
    calcButtonClass(state) {
      const {
        busy,
        valid,
        hasTriedToSubmitForm,
        editMode,
        formType,
        changeState
      } = state;
      if (busy) return 'ui-button-grey';
      if (!valid && hasTriedToSubmitForm) return 'ui-button-danger';
      if (formType === 'editor') {
        if (editMode === 'edit') {
          return changeState === 'unchanged' ? 'ui-button-grey' : 'ui-button-primary';
        } else {
          return 'ui-button-primary';
        }
      } else {
        if (formType === 'form' && hasTriedToSubmitForm) return 'ui-button-grey';
      }
      return '';
    }
    calcButtonIcon(state) {
      const {
        saveState,
        valid,
        hasTriedToSubmitForm,
        editMode,
        formType,
        changeState
      } = state;
      if (!valid && hasTriedToSubmitForm) return 'exclamation-triangle';
      if (formType === 'editor') {
        if (editMode === 'edit') {
          if (saveState === 'saved' || changeState === 'unchanged') return 'check';else return this.customIcon || 'save';
        } else {
          if (saveState === 'saved') return 'check';else return this.customIcon || 'save';
        }
      } else {
        if (saveState === 'saved') return 'check';
      }
      return this.customIcon || 'chevron-right';
    }
    onClick(e) {
      if (this.handler) this.handler();else if (this.service) this.service.save();
      this.comp.el.nativeElement.blur();
    }
    // normally, pressing enter or space would trigger a click event that's indestinguishable.
    // but we want different behavior for real clicks (autoblur for clean UI)
    // so we catch the keyboard events that'd trigger a click event with a manual implementation.
    onKey(e) {
      if (e.code === "Enter" || e.code === "Space") {
        e.preventDefault();
        if (this.handler) this.handler();else if (this.service) this.service.save();
      }
    }
    static {
      this.ɵfac = function FormSubmitButtonDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FormSubmitButtonDirective)(i0.ɵɵdirectiveInject(i1.UiButtonComponent));
      };
    }
    static {
      this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
        type: FormSubmitButtonDirective,
        selectors: [["", "uiButton", "", "formSubmitButton", ""]],
        hostVars: 4,
        hostBindings: function FormSubmitButtonDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("click", function FormSubmitButtonDirective_click_HostBindingHandler($event) {
              return ctx.onClick($event);
            })("keydown", function FormSubmitButtonDirective_keydown_HostBindingHandler($event) {
              return ctx.onKey($event);
            });
          }
          if (rf & 2) {
            i0.ɵɵattribute("disabled", ctx.buttonDisabled)("e2e-form-submit-button", ctx.e2eStateAttr);
            i0.ɵɵclassProp("form-submit-button", ctx.isSubmitBtn);
          }
        },
        inputs: {
          formSubmitButton: "formSubmitButton",
          handler: [0, "formSubmitHandler", "handler"],
          _options: [0, "formSubmitButtonOptions", "_options"]
        }
      });
    }
  }
  return FormSubmitButtonDirective;
})();